/**
 * Developer logo registry — client-side only.
 *
 * Split from `developers.ts` because these are bundler asset imports;
 * the data module is also imported by the server (sitemap/prerender),
 * which must stay free of image imports.
 */

import alHabtoorLogo from "../../developers-logo/al-habtoor.png";
import aldarLogo from "../../developers-logo/aldar.png";
import aradaLogo from "../../developers-logo/arada.svg";
import aziziLogo from "../../developers-logo/azizi.svg";
import binghattiLogo from "../../developers-logo/binghatti.webp";
import damacLogo from "../../developers-logo/uq8ic3y3kddtbbru30bh.webp";
import danubeLogo from "../../developers-logo/danube.svg";
import deyaarLogo from "../../developers-logo/deyaar.svg";
import dubaiHoldingLogo from "../../developers-logo/Dubai_Holding_logo.png";
import ellingtonLogo from "../../developers-logo/Ellington-properties-Logo.png";
import emaarLogo from "../../developers-logo/Emaar-Properties-Logo-1.png";
import expoCityLogo from "../../developers-logo/expo-city.png";
import imtiazLogo from "../../developers-logo/imtiaz.svg";
import magLogo from "../../developers-logo/mag.webp";
import majidAlFuttaimLogo from "../../developers-logo/majid-al-futtaim.png";
import meraasLogo from "../../developers-logo/Meraas-logo.svg";
import nakheelLogo from "../../developers-logo/Nakheel_Properties_logo.svg.png";
import nshamaLogo from "../../developers-logo/nshama.svg";
import object1Logo from "../../developers-logo/object-1.svg";
import omniyatLogo from "../../developers-logo/omniyat.svg";
import reportageLogo from "../../developers-logo/reportage.png";
import samanaLogo from "../../developers-logo/samana.png";
import selectGroupLogo from "../../developers-logo/select-group.svg";
import sobhaLogo from "../../developers-logo/Sobha_(company).svg.png";
import tigerLogo from "../../developers-logo/tiger.webp";
import unionPropertiesLogo from "../../developers-logo/union-properties.png";
import waslLogo from "../../developers-logo/wasl.png";

export interface DeveloperLogo {
  src: string;
  /** Height class tuned per artwork so the plate reads balanced. */
  className: string;
}

/** Keyed by `DeveloperContent.slug`. */
export const DEVELOPER_LOGOS: Record<string, DeveloperLogo> = {
  emaar: { src: emaarLogo, className: "h-6 sm:h-7" },
  damac: { src: damacLogo, className: "h-8 sm:h-9" },
  sobha: { src: sobhaLogo, className: "h-6 sm:h-7" },
  ellington: { src: ellingtonLogo, className: "h-7 sm:h-8" },
  "dubai-holding": { src: dubaiHoldingLogo, className: "h-8 sm:h-9" },
  meraas: { src: meraasLogo, className: "h-6 sm:h-7" },
  nakheel: { src: nakheelLogo, className: "h-9 sm:h-10" },
  binghatti: { src: binghattiLogo, className: "h-6 sm:h-7" },
  azizi: { src: aziziLogo, className: "h-5 sm:h-6" },
  danube: { src: danubeLogo, className: "h-7 sm:h-8" },
  aldar: { src: aldarLogo, className: "h-9 sm:h-10" },
  omniyat: { src: omniyatLogo, className: "h-4 sm:h-5" },
  "select-group": { src: selectGroupLogo, className: "h-7 sm:h-8" },
  deyaar: { src: deyaarLogo, className: "h-6 sm:h-7" },
  mag: { src: magLogo, className: "h-8 sm:h-9" },
  "majid-al-futtaim": { src: majidAlFuttaimLogo, className: "h-6 sm:h-7" },
  wasl: { src: waslLogo, className: "h-6 sm:h-7" },
  nshama: { src: nshamaLogo, className: "h-4 sm:h-5" },
  "al-habtoor": { src: alHabtoorLogo, className: "h-9 sm:h-10" },
  arada: { src: aradaLogo, className: "h-5 sm:h-6" },
  samana: { src: samanaLogo, className: "h-7 sm:h-8" },
  tiger: { src: tigerLogo, className: "h-7 sm:h-8" },
  imtiaz: { src: imtiazLogo, className: "h-6 sm:h-7" },
  "union-properties": { src: unionPropertiesLogo, className: "h-8 sm:h-9" },
  reportage: { src: reportageLogo, className: "h-5 sm:h-6" },
  "expo-city": { src: expoCityLogo, className: "h-8 sm:h-9" },
  "object-1": { src: object1Logo, className: "h-6 sm:h-7" },
};
